"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var BasicIcon_1 = __importDefault(require("../../../../../../components/common/BasicIcon"));
var PostingMortgage_1 = require("../../../../../../constants/PostingMortgage");
var react_i18next_1 = require("react-i18next");
var schemaHelper_1 = require("../../../../../../helpers/schemaHelper");
var MortgageCardForm_1 = __importDefault(require("./MortgageCardForm"));
var FormActions_1 = __importDefault(require("./MortgageCardForm/FormActions"));
var classnames_1 = __importDefault(require("classnames"));
var PostTabsContext_1 = require("../../../../../../contexts/PostTabsContext");
var styles_module_scss_1 = __importDefault(require("../../styles.module.scss"));
var MortgageCard = function (_a) {
    var _b, _c;
    var step = _a.step, formikProps = _a.formikProps, post = _a.post, isLoaded = _a.isLoaded;
    var t = react_i18next_1.useTranslation('common').t;
    var rows = step.fields.rows, order = step.order, name = step.name;
    var tabRef = react_1.useRef(null);
    var handleTabPositionChange = react_1.useContext(PostTabsContext_1.PostTabsContext).handleTabPositionChange;
    var primaryRows = rows.filter(function (r) { return !r.config.collapsed; });
    var mediaDescriptionRows = primaryRows.splice(-2);
    var validatedMediaDescriptionRows = schemaHelper_1.excludeFieldsByCondition(mediaDescriptionRows, formikProps.values);
    react_1.useEffect(function () {
        if (tabRef.current && rows) {
            handleTabPositionChange(name, tabRef.current.offsetTop, tabRef.current.offsetTop + tabRef.current.offsetHeight);
        }
    }, [isLoaded, (_b = tabRef.current) === null || _b === void 0 ? void 0 : _b.offsetTop, (_c = tabRef.current) === null || _c === void 0 ? void 0 : _c.offsetHeight]);
    var addNewMortgage = function () {
        formikProps.setFieldValue('mortgage', __spreadArray(__spreadArray([], formikProps.values.mortgage), [
            PostingMortgage_1.DefaultMortgageData(),
        ]));
    };
    var removeMortgage = function (id) {
        var filteredMortgageList = formikProps.values.mortgage.filter(function (item) { return item.id !== id; });
        formikProps.setFieldValue('mortgage', filteredMortgageList);
        addRemovedMortgageId(id);
    };
    var addRemovedMortgageId = function (id) {
        formikProps.setFieldValue('removedMortgageIds', __spreadArray(__spreadArray([], formikProps.values.removedMortgageIds), [
            id,
        ]));
    };
    if (!rows) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return (react_1.default.createElement("div", { ref: tabRef },
        react_1.default.createElement("div", { className: classnames_1.default('element form-section', styles_module_scss_1.default.card), key: order },
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: styles_module_scss_1.default.card_header },
                    react_1.default.createElement("span", { className: styles_module_scss_1.default.header_title },
                        react_1.default.createElement(BasicIcon_1.default, { iconClass: step.icon }),
                        react_1.default.createElement("h3", null, t(name)))),
                react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.card_content, styles_module_scss_1.default.building_card) }, formikProps.values[name].map(function (item, index) { return (react_1.default.createElement("div", { key: index },
                    react_1.default.createElement(MortgageCardForm_1.default, { index: index, formikProps: formikProps, order: order, name: name, post: post, validatedMediaDescriptionRows: validatedMediaDescriptionRows, mortgageId: item.id, addRemovedMortgageId: addRemovedMortgageId }),
                    react_1.default.createElement(FormActions_1.default, { isLast: index + 1 ===
                            formikProps.values[name].length, isFirst: formikProps.values[name].length ===
                            1, index: item.id, addNewMortgage: addNewMortgage, removeMortgage: removeMortgage }))); }))))));
};
exports.default = MortgageCard;
